// extracted by mini-css-extract-plugin
export var testimonials = "testimonials-module--testimonials--3sor5";
export var testimonialsSlideShowContainer = "testimonials-module--testimonialsSlideShowContainer--1X5fa";
export var testimonialsSlideShow = "testimonials-module--testimonialsSlideShow--34Ffa";
export var testimonialSlide = "testimonials-module--testimonialSlide--1J4xf";
export var testimonialContainer = "testimonials-module--testimonialContainer--2xb07";
export var imageSection = "testimonials-module--imageSection--3StWI";
export var image = "testimonials-module--image--1u1Cy";
export var projImage = "testimonials-module--projImage--2wDfU";
export var attestantDetails = "testimonials-module--attestantDetails--2CGvg";
export var testimony = "testimonials-module--testimony--3oZ88";
export var slideBeads = "testimonials-module--slideBeads--2HigS";
export var active = "testimonials-module--active--fhE8j";
export var left = "testimonials-module--left--3Bvx0";
export var right = "testimonials-module--right--3Smc3";
export var organizations = "testimonials-module--organizations--1w7WB";
export var organization = "testimonials-module--organization--CQDju";
export var gdsc = "testimonials-module--gdsc--2aJdD";